import gql from 'graphql-tag';

export default gql`
  query {
    userProfile {
      id
      email
      test
      admin
      name
      institution {
        id
        name
      }
      institutionType
      status
    }
  }
`;
